import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI, DatePickerUI, InputUI } from '../Interface';

const OtherExpenseFields = ({ viewField, selectedValues, autocompleteOptions }) => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-1">
        <Field
          type="date"
          name="date"
          component={DatePickerUI}
          value={values.date}
          fullWidth
          disabled={viewField}
          label={<FormLabelUI text="Dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.date} />}
          onChange={(date) => {
            setFieldValue('date', date).then(() => {
              validateField('date');
            });
          }}
          InputLabelProps={{ shrink: values.date !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="costAndRevenueTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Költség fajta" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costAndRevenueTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('costAndRevenueTypeId', newVal?.value ?? null).then(() => {
              validateField('costAndRevenueTypeId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.costAndRevenueTypeId !== '' }}
          selectedValue={values.costAndRevenueTypeId}
          selectedLabelValue={selectedValues?.costAndRevenueType?.name}
          dataset={autocompleteOptions.costAndRevenue}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="costCenterCode"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Költséghely" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costCenterCode} />}
          onChange={(_e, newVal) => {
            setFieldValue('costCenterCode', newVal?.value ?? null).then(() => {
              validateField('costCenterCode');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.costCenterCode !== '' }}
          selectedValue={values.costCenterCode}
          selectedLabelValue={selectedValues?.costCenter?.name}
          dataset={autocompleteOptions.costCenter}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="projectId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectId} />}
          onChange={(_e, newVal) => {
            setFieldValue('projectId', newVal?.value ?? null).then(() => {
              validateField('projectId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.projectId !== '' }}
          selectedValue={values.projectId}
          selectedLabelValue={selectedValues?.project?.projectName}
          dataset={autocompleteOptions.project}
        />
      </div>
    </div>
  );
};

export default OtherExpenseFields;
